import { useCallback, useEffect, useRef } from "react";
import { LG, useMediaQuery } from "./useMediaQuery";

/** On stacked (below lg) queue layouts, brings the decision panel into view after the user picks an item. */
export function useRevealPanel(activeID: string | null) {
  const wide = useMediaQuery(LG);
  const panelRef = useRef<HTMLElement>(null);
  const headingRef = useRef<HTMLHeadingElement>(null);
  // Set only by a pick, so a deep link or a cleared selection never scrolls.
  const picked = useRef(false);

  const show = useCallback(() => {
    panelRef.current?.scrollIntoView?.({ block: "start" });
    headingRef.current?.focus({ preventScroll: true });
  }, []);

  useEffect(() => {
    if (!picked.current) return;
    picked.current = false;
    if (!wide && activeID !== null) show();
  }, [activeID, wide, show]);

  const reveal = (id: string) => {
    if (wide) return;
    // Re-picking the current item changes nothing in the URL, so the effect would not run.
    if (id === activeID) show();
    else picked.current = true;
  };

  return { panelRef, headingRef, reveal };
}
